import React from 'react'; 
import PropTypes from 'prop-types';
import RadioSection from '../../RadioSection';
import TextBox from '../../../Basic/TextBox';
import SectionHeader from '../../../Basic/SectionHeader';
import util from '../../../../lib/util';
class IdType extends React.Component {
    render() {
        const lookup = window.osa.lookup.customerDetails.idType;
        const p = this.props;
        let idTypeControl = null;
        let idTypeOption = null;
        if (p.customerType == "1") {
            idTypeOption = <RadioSection name={p.name} items={lookup.items} inline disabled={p.disabled} />;
            switch (p.idType) {
                case "1":
                    idTypeControl = (
                        <div>
                            <TextBox name={p.name + "_DriverLicence"} title={lookup.items[0].name} disabled={p.disabled} required maxLength={50} />
                            <div>e.g. 1234567</div>
                        </div>
                    );
                    break;
                case "2":
                    idTypeControl = (<TextBox name={p.name + "_BCIdentification"} title={lookup.items[1].name}
                        disabled={p.disabled} required maxLength={50} />);
                    break;
                case "3":
                    idTypeControl = (<TextBox name={p.name + "_PassportNo"} title={lookup.items[2].name}
                        disabled={p.disabled} required maxLength={50} />);
                    break;
            }
        }
        else
            if (p.customerType == "2" || p.customerType == "3") {
                idTypeControl = (<TextBox name={p.name + "_BusinessNumber"} title="Business Number" disabled={p.disabled}
                    pattern="^[0-9]{9}$" patternErrorMsg="Please enter a valid nine-digit business number" required />);
            }
        return (
            <div>
                <SectionHeader title={lookup.title} />
                {idTypeOption}
                <div className="row">
                    <div className="col-sm-4">
                        {idTypeControl}
                    </div>
                </div>
            </div>
        );
    }
}
IdType.propTypes = {
    name: PropTypes.string.isRequired,
    idType: PropTypes.string,
    customerType: PropTypes.string.isRequired,
    disabled: PropTypes.bool
};

export default IdType;

export function IdTypeValidation(name, idType, customerType, bupaVerified) {
    if (bupaVerified)
        return [];
    if (customerType == "1") {
        switch (idType) {
            case "1":
                return [[name + "_DriverLicence", p => p[name + "_DriverLicence"], "Driver's licence number"]];
            case "2":
                return [[name + "_BCIdentification", p => p[name + "_BCIdentification"], "BC identification number"]];
            case "3":
                return [[name + "_PassportNo", p => p[name + "_PassportNo"], "Passport number"]];
        }
    }
    else
        if (customerType == "2" || customerType == "3")
            return [[name + "_BusinessNumber", p => p[name + "_BusinessNumber"], "Business Number"],
            [name + "_BusinessNumber", p => util.isBNValid(p[name + "_BusinessNumber"]), "#Please enter a valid nine-digit business number"]];
}